import { API_URL } from '@/lib/api';

// ─── Notifications API Functions ─────────────────────────────────────
// Standalone fetch functions extracted from NotificationsContext.

export interface NotificationItem {
  id: string;
  type: string;
  title: string;
  body: string | null;
  data: Record<string, any> | null;
  read: boolean;
  createdAt: string;
}

export async function fetchNotifications(token: string): Promise<{ items: NotificationItem[]; unreadCount: number }> {
  const res = await fetch(`${API_URL}/notifications?limit=50&offset=0`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to fetch notifications (${res.status})`);
  const data = await res.json();
  return {
    items: Array.isArray(data.items) ? data.items : [],
    unreadCount: data.unreadCount ?? data.unread_count ?? 0,
  };
}

export async function markNotificationAsReadAPI(token: string, notificationId: string): Promise<void> {
  const res = await fetch(`${API_URL}/notifications/${notificationId}/read`, {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to mark notification as read (${res.status})`);
}

export async function markAllNotificationsAsReadAPI(token: string): Promise<void> {
  const res = await fetch(`${API_URL}/notifications/read-all`, {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to mark all as read (${res.status})`);
}

export async function deleteNotificationAPI(token: string, notificationId: string): Promise<void> {
  const res = await fetch(`${API_URL}/notifications/${notificationId}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to delete notification (${res.status})`);
}

export async function registerPushTokenAPI(token: string, pushToken: string, platform: string, appVersion: string): Promise<void> {
  const res = await fetch(`${API_URL}/notifications/push-token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      token: pushToken,
      platform,
      app_version: appVersion,
    }),
  });
  if (!res.ok) {
    const errorText = await res.text().catch(() => '');
    console.error(`Failed to register push token (status ${res.status}): ${errorText}`);
  }
}